import Component from './FileAnnotations';
import createRenderer from './FileAnnotations.relay';
export default createRenderer(Component);



// WEBPACK FOOTER //
// ./src/packages/@ncigdc/modern_components/FileAnnotations/index.js